@if (visible()) {
  <div class="notranslate" [attr.translate]="'no'" role="alert">
    <app-top-banner-shell variant="warning">
      <app-top-banner-row
        [textContent]="'browserTranslation.warning' | translate"
        (dismiss)="dismiss()">
      </app-top-banner-row>
    </app-top-banner-shell>
  </div>
}
